import Accordion from "./Classes/Accordion";
import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import TableIconReplacer from "./Classes/TableIconReplacer.js";
import XDownloader from "./Classes/XDownloader";
import xdownloaderConfig from "./xdownloader-config";
import Cv from "./Classes/Cv";
import Anchor from "./Classes/Anchor";
import Video from "./Classes/Video";
import Lottie from "./Classes/Lottie";
import LottieAccordion from "./Classes/LottieAccordion";
import PrivacySettings from "./Classes/PrivacySettings";

window.addEventListener("page_event_load", () => {
  new Accordion({
    accordions: '.lc-accordion',
    pxCorrectionMobile: 110,
    pxCorrectionDesktop: 105,
    mobileBreakpoint: 1025
  });

  new Swiper('.swiper', {
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
     speed: 900,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  new Lottie();
  new LottieAccordion();
  new TableIconReplacer();
  new PrivacySettings();

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

  // new XDownloader(xdownloaderConfig);

  new Cv();
  new Anchor();
  new Video({
    videoComponentSelector: '.lc-video',
    videoButtonSelector: '.lc-video__thumbnail-container',
  });
});

window.addEventListener('note_event_load', evt => {
  // console.log("note loaded event");
  document.body.classList.add("note-open");

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

});


window.addEventListener('note_unloaded', evt => {
  //console.log("note unloaded event");
  document.body.classList.remove("note-open");
});
